import {
  CompanyAccountStatus,
  useOrderInfo,
  useOrgInfo,
  useUserInfo,
} from "@src/common/reliablePartnerApi";
import { RPFormattedMessage } from "@src/i18n";

const AdminNotifications = () => {
  const userInfo = useUserInfo();

  if (!userInfo.data?.isAdmin) {
    return null;
  }

  return (
    <>
      <CompanyAccountStatusInfo />
      <LicenseStatusInfo />
    </>
  );
};

export default AdminNotifications;

const CompanyAccountStatusInfo = () => {
  const orgInfo = useOrgInfo();

  switch (orgInfo.data?.companyAccountStatus) {
    case CompanyAccountStatus.PENDING:
      return (
        <div
          className="alert alert-warning mt-4"
          id="admin-notification-company-account-pending"
        >
          <i
            className="fa fa-info-circle mr-4 align-self-center"
            aria-hidden="true"
          ></i>
          <RPFormattedMessage
            id="adminNotificationCompanyAccountPending"
            defaultMessage="Ole hyvä ja viimeistele yrityksesi rekisteröinti täällä <linkToCompanyAccount>yritystili</linkToCompanyAccount>."
          />
        </div>
      );
    case CompanyAccountStatus.NOK:
      return (
        <div
          className="alert alert-warning mt-4"
          id="admin-notification-company-account-nok"
        >
          <i
            className="fa fa-info-circle mr-4 align-self-center"
            aria-hidden="true"
          ></i>
          <RPFormattedMessage
            id="adminNotificationCompanyAccountTerminated"
            defaultMessage="<linkToCompanyAccount>Yrityksesi sivuilla</linkToCompanyAccount> on jotakin selvitystä vaativaa."
          />
        </div>
      );
    default:
      // We're only interested in informing about problems with the
      // company account for now.
      return null;
  }
};

const LicenseStatusInfo = () => {
  const orderInfo = useOrderInfo();

  if (!orderInfo.isSuccess) {
    return null;
  }

  if (orderInfo.data.license === null) {
    return (
      <div
        className="alert alert-warning mt-4"
        id="admin-notification-license-missing"
      >
        <i
          className="fa fa-info-circle mr-4 align-self-center"
          aria-hidden="true"
        ></i>
        <RPFormattedMessage
          id="adminNotificationNotOrdered"
          defaultMessage="Yritystäsi <b>{orgName}</b> ei ole vielä liitetty Luotettava Kumppani tilaajavastuutiedot -palveluun."
        />
      </div>
    );
  }

  // A non-active (inactive) license does not warrant a separate
  // notification for now. Missing license is handled above.
  return null;
};
